import styled from '@emotion/styled';

import { Switch, FormControlLabel } from '@mui/material';

const MuiSwitch = ({ value = false, onChange, label, ...props }) => {
  return (
    <FormControlLabel control={<Switch
      checked={value}
      onChange={onChange}
      {...props}
      />} label={label} />
  );
};

export default MuiSwitch;
